import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {kitchenTableReady,rowsPerPageState,searchTextState,paginationState,kitchenIdForAction,previousKitchenFilterCity,previousKitchenFilterCluster} from '../redux/kitchens'
import {addEditStoreKitchenDataForAction,addEditStoreIdForAction} from '../../Stores/redux/stores'



import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'


import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/kitchenTable.css'

import CollapsibleStoreRow from './CollapsibleStoreRow'

import { CSVLink } from 'react-csv'
import { createXLSheetdata } from '../services/helpers'


import {Cities,ClusterCombo} from '../../../common/DropDowns/index'


import moment from 'moment'


import * as Helpers from '../../../common/helpers'






function filterUnwantedData(kitchensData) {
    let array = []
    if (kitchensData && kitchensData.data && kitchensData.data.list) {
        array = kitchensData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.kitchen_name = lineData.name ? lineData.name : "NA"
            newLineData.kitchen_code = lineData.code ? lineData.code : "NA"
            newLineData.kitchen_manager_name =  lineData.kitchen_manager && lineData.kitchen_manager.name ? lineData.kitchen_manager.name : "NA"
            newLineData.cluster_name =  lineData.cluster && lineData.cluster.name ? lineData.cluster.name : "NA"
            newLineData.cluster_manager_name =  lineData.cluster && lineData.cluster.cluster_manager && lineData.cluster.cluster_manager.name ? lineData.cluster.cluster_manager.name : "NA"

            newLineData.city_name = lineData.city && lineData.city.name ? lineData.city.name : "NA"

            newLineData.location = lineData.lat ? lineData.lat+ " , " + lineData.lng : "NA"
            newLineData.status =lineData.status ? lineData.status : "NA"

            newLineData.stores=[];
            for (let j = 0; j < lineData.stores.length; j++) {
                let newStoreData = {}
                newStoreData.id=lineData.stores[j].id ? lineData.stores[j].id : "NA"
                newStoreData.name=lineData.stores[j].name ? lineData.stores[j].name : "NA"
                newStoreData.urbanpiper_id=lineData.stores[j].urbanpiper_id ? lineData.stores[j].urbanpiper_id : "NA"
                newStoreData.status=lineData.stores[j].status ? lineData.stores[j].status : "NA"
                newStoreData.business_status=lineData.stores[j].business_status ? lineData.stores[j].business_status : ""
                newStoreData.business_remarks=lineData.stores[j].business_remarks ? lineData.stores[j].business_remarks : ""
                newStoreData.brand_name=lineData.stores[j].brand && lineData.stores[j].brand.name ? lineData.stores[j].brand.name : "NA"



                
                newStoreData.store_timings=[]
                if(lineData.stores[j].store_timings.length>0){                    
                    for (let k = 0; k < lineData.stores[j].store_timings.length; k++) {
                        let newStoreTimingData = {}
                        newStoreTimingData.time=lineData.stores[j].store_timings[k].start_time+" - "+lineData.stores[j].store_timings[k].end_time+" ( "+lineData.stores[j].store_timings[k].end_day.replaceAll("_"," ")+" )"
                        newStoreData.store_timings[k]=newStoreTimingData
                    }
                }

                newStoreData.store_platforms=[]
                if(lineData.stores[j].store_platforms.length>0){                    
                    for (var k = 0; k < lineData.stores[j].store_platforms.length; k++) {
                        let obj = {}
                        obj.platform=lineData.stores[j].store_platforms && lineData.stores[j].store_platforms[k].platform && lineData.stores[j].store_platforms[k].platform.name ? lineData.stores[j].store_platforms[k].platform.name: ""
                        newStoreData.store_platforms[k]=obj
                    }
                }


                newLineData.stores[j]=newStoreData
            }


            newArray[i] = newLineData
        }
    }

    
    return newArray
}


class KitchensTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            kitchenData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            filter_city_id:"",
            filter_cluster_id:"",
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null

        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(kitchenTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.KITCHENS_TABLE))   
        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()


            let previousKitchenFilterCity=""
            let previousKitchenFilterCluster=""

         if (this.props.kitchens && this.props.kitchens.previousKitchenFilterCity && this.props.kitchens.previousKitchenFilterCity!==undefined) {
            previousKitchenFilterCity=this.props.kitchens.previousKitchenFilterCity
         }
         if (this.props.kitchens && this.props.kitchens.previousKitchenFilterCluster && this.props.kitchens.previousKitchenFilterCluster!==undefined) {
            previousKitchenFilterCluster=this.props.kitchens.previousKitchenFilterCluster
         }

         this.setState({
              filter_city_id:previousKitchenFilterCity,
              filter_cluster_id:previousKitchenFilterCluster
         },() => {
            this.getKitchensData()
        });

        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getKitchensData = () => {
        apiService.getKitchensData(this.state.filter_city_id,this.state.filter_cluster_id)
            .then(kitchensData => {
                if (kitchensData && this.isComponentMounted) {
                    this.validateBuildNumber(kitchensData)
                    if (kitchensData.status === "SUCCESS") {
                        let array = filterUnwantedData(kitchensData), pageNo = 1
                        if (this.props.kitchens && this.props.kitchens.previousPaginationValue) {
                            pageNo = this.props.kitchens.previousPaginationValue
                        }
                        this.setState({
                            kitchenData: array,
                            page: pageNo,
                        })

                        this.createCSVData(array)
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: kitchensData.reason ? kitchensData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(kitchenTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(kitchenTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }




    createCSVData(csvData) {
        let kitchenList = []
        if (csvData) {
            kitchenList = JSON.parse(JSON.stringify(csvData))
            kitchenList = createXLSheetdata(kitchenList)
        }
        this.CSVData = kitchenList
    }




    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.kitchens && this.props.kitchens.previousRowsPerPageValue) {
            value = this.props.kitchens.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {



        let kitchenListFilename = "kitchens_list_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"

        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                  


{(() =>{

    if(Helpers.checkPrivileges("/dashboard/kitchens/add",this.props.user)){
        return(
                    
                   <div className="col-md-1 col-sm-12 col-xs-12 div-margins">
                  
                   <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.dispatch(kitchenIdForAction())
                                this.props.history.push("/dashboard/kitchens/addEdit")
                            }}>
                            Add
                        </button>
                    
                    </div>
                    )
        }
})()}


                    <div className="col-md-3 col-sm-12 col-xs-12 div-margins">
                        <div className="form-group">
                                   <Cities cityChange={this.cityChange} selectedValue={this.state.filter_city_id}/>    
                                </div>
                    </div>
                    <div className="col-md-3 col-sm-12 col-xs-12 div-margins">
                        <div className="form-group">
                                   <ClusterCombo clusterChange={this.clusterChange} selectedValue={this.state.filter_cluster_id}/>    
                                </div>
                    </div>
                   <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredKitchenList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>

                        <CSVLink
                            data={this.CSVData}
                            className="btn btn-primary button-custom"
                            style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                            filename={kitchenListFilename}>
                            Export
                        </CSVLink>
                    </div>

                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
     createCustomFooter = props => {


        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.kitchenData.length>=(this.props.kitchens.previousPaginationValue*this.props.kitchens.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.kitchens.previousPaginationValue*this.props.kitchens.previousRowsPerPageValue)-this.props.kitchens.previousRowsPerPageValue+1} to {this.props.kitchens.previousPaginationValue*this.props.kitchens.previousRowsPerPageValue} of {this.state.kitchenData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.kitchens.previousPaginationValue*this.props.kitchens.previousRowsPerPageValue)-this.props.kitchens.previousRowsPerPageValue+1} to {this.state.kitchenData.length} of {this.state.kitchenData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredKitchenList = () => {
       
        this.props.dispatch(kitchenTableReady(false))
        this.resetSearchAndPagination()
        this.getKitchensData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getKitchensData()
        this.props.dispatch(kitchenTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }

      resetFilterValues = () => {
        this.props.dispatch(kitchenTableReady(false))
        this.setState({
            filter_city_id: "",
            filter_cluster_id: ""
        },() => {
        this.resetPagination()
        this.props.dispatch(searchTextState(""))

        this.props.dispatch(previousKitchenFilterCity(""))
        this.props.dispatch(previousKitchenFilterCluster(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")

        this.getKitchensData();
        });

    }
    

    actionButtonsCreator = (cell, row) => {
        let viewKitchenTeam = "";
        let addStoreBtn= ""
        let editKitchenBtn= ""
        
        if(Helpers.checkPrivileges("/dashboard/kitchens/viewTeam",this.props.user)){

           
        viewKitchenTeam=       
            <button
                title="View Employee"
                className="action-button"
                style={{ width: "30px", marginBottom: "1px",background:"green" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.viewKitchenTeam(row)
                }}>
                <i  title="View Kitchen Team" className="fa fa-group" aria-hidden="true"></i>
            </button>
        }

        if(Helpers.checkPrivileges("/dashboard/stores/addEdit",this.props.user)){


        addStoreBtn=       
            <button
                title="Add Store"
                className="action-button"
                style={{ width: "30px", marginBottom: "1px",background:"teal" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.addStore(row)
                }}>
                <i  title="Add Store" className="fa fa-plus" aria-hidden="true"></i>
            </button>
        }

        if(Helpers.checkPrivileges("/dashboard/kitchens/addEdit",this.props.user)){


        editKitchenBtn=       
            <button
                title="Add Store"
                className="action-button"
                style={{ width: "30px", marginBottom: "1px",background:"teal" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.editKitchen(row)
                }}>
                <i  title="Edit kitchen" className="fa fa-pencil-square-o" aria-hidden="true"></i>
            </button>
        }
            

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editKitchenBtn}{viewKitchenTeam}{addStoreBtn}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.kitchens && this.props.kitchens.previousPaginationValue
            && this.props.kitchens.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }


    

    viewKitchenTeam = (row) => {
        if (row && row.id) {
            this.props.dispatch(kitchenIdForAction(row.id))
            this.props.history.push("/dashboard/kitchens/viewTeam")
        } else {
            this.dialog.show({
                title: "Kitchen Identification number not found",
                body: 'Kitchen id is not available, So not able view kitchen team',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }



    addStore = (row) => {
        if (row && row.id) {
            this.props.dispatch(addEditStoreIdForAction())
            this.props.dispatch(addEditStoreKitchenDataForAction(row))
            this.props.history.push("/dashboard/stores/addEdit")
        } else {
            this.dialog.show({
                title: "Kitchen Identification number not found",
                body: 'Kitchen id is not available, So not able view kitchen team',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }



    editKitchen = (row) => {
        if (row && row.id) {
            this.props.dispatch(kitchenIdForAction(row.id))
            this.props.history.push("/dashboard/kitchens/addEdit")
        } else {
            this.dialog.show({
                title: "Kitchen Identification number not found",
                body: 'Kitchen id is not available, So not able edit kitchen',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

     expandComponent = row => {
        let row_id = ""
        if (row && row.id) {
            row_id = row.id
        }
        return <CollapsibleStoreRow row={row} row_id={row_id}/>
    }

    isExpandableRow = row => {
        return true
    }


    expandColumnComponent = ({ isExpandableRow, isExpanded }) => {
        let downIconClassName = ""
        if (isExpandableRow) {
            downIconClassName = (isExpanded ? 'fa fa-angle-double-up' : 'fa fa-angle-double-down')
        } else {
            downIconClassName = ""
        }
        return (
            <div className="custom-expandable-row-indicator">
                <span className={downIconClassName} />
            </div>
        )
    }

    cityChange = (data) => {
        if(data.value==="" || data.value===undefined){
                 this.props.dispatch(previousKitchenFilterCity(""))
                  this.setState({
                    filter_city_id :"",            
                })
            }else{
                this.props.dispatch(previousKitchenFilterCity(data.value))
                this.setState({
                filter_city_id :data.value,
                
                })
            }
     }


    clusterChange = (data) => {
        if(data.value==="" || data.value===undefined){
                 this.props.dispatch(previousKitchenFilterCluster(""))
                  this.setState({
                    filter_cluster_id :"",            
                })
            }else{
                this.props.dispatch(previousKitchenFilterCluster(data.value))
                this.setState({
                filter_cluster_id :data.value,
                
                })
            }
     }




    

    render() {
        let sizeperPage = 15

        if (this.props.kitchens && this.props.kitchens.previousRowsPerPageValue) {
            sizeperPage = this.props.kitchens.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="kitchens-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.kitchenData}
                    pagination={true}
                    expandableRow={this.isExpandableRow}
                    expandComponent={this.expandComponent}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                    expandColumnOptions={{
                        expandColumnVisible: true,
                        rerenderOnDataChange: true,
                        expandColumnComponent: this.expandColumnComponent
                    }}>

                    {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                    <TableHeaderColumn
                        dataField="kitchen_name"
                        dataAlign='left'
                        dataSort={true}
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="kitchen_code"
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Code
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="kitchen_manager_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Kitchen Manager
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="cluster_name"
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Cluster
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataField="cluster_manager_name"
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Cluster Manager
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="city_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        City
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="status"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Status
                    </TableHeaderColumn>
                    
                    
                     <TableHeaderColumn
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        kitchens: state.kitchens
    }
}

export default connect(mapStateToProps)(withRouter(KitchensTable))


// WEBPACK FOOTER //
// ./src/modules/Kitchens/Components/KitchensTable.js